// extracted by mini-css-extract-plugin
export default {"wrap":"FB-z","fullWidth":"GB-z","items":"HB-z","featureCss":"IB-z","disabled":"JB-z","imgCss":"KB-z"};